/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

//aタグ スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

$(function(){
  const $slider = $('.home-imgs__slider');

  if($slider[0]) {

    $slider.find('.home-imgs__slide').clone().appendTo($slider);

    setTimeout(function(){
      setWidth();
      $slider.addClass('is-ani');
    }, 100);

    $(window).on('resize', function(event) {
      setWidth();
    });

    function setWidth() {
      let w = 0;
      $slider.find('.home-imgs__slide').each(function(index, el) {
        w += $(this).innerWidth();
        $slider.css('width', w);
      });
    }
  }
})